import {
  faSackDollar,
  faCalendarDays,
  faChartPie,
  faReceipt,
  faCartShopping,
} from "@fortawesome/free-solid-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  useFaturamentoDiario,
  useFaturamentoMensal,
  useMargemLucro,
  useTicketMedio,
  useTotalVendas,
} from "../../../hooks/useDashboardStats";
import { StatType } from "../../../types/stats";
import { formatStatValue } from "utils/formatters";
import DashStatTile from "./v2/DashStatTile";

type DashIconVariant = "accent" | "good" | "warning" | "critical" | "accent2";

const Tile = ({
  query,
  label,
  icon,
  variant,
  footnote,
}: {
  query: { data?: { data: { data: StatType } }; isLoading: boolean };
  label: string;
  icon: IconDefinition;
  variant: DashIconVariant;
  footnote?: string;
}) => {
  const stat = query.data?.data?.data;

  return (
    <DashStatTile
      label={label}
      value={stat ? formatStatValue(stat) : ""}
      icon={icon}
      variant={variant}
      isLoading={query.isLoading}
      change={stat?.change}
      footnote={footnote}
    />
  );
};

const AnalyticsStats = () => {
  const faturamentoDiario = useFaturamentoDiario();
  const faturamentoMensal = useFaturamentoMensal();
  const margemLucro = useMargemLucro();
  const ticketMedio = useTicketMedio();
  const totalVendas = useTotalVendas();

  return (
    <div className="dash-grid dash-grid-5">
      <Tile query={faturamentoDiario} label="Faturamento Diário" icon={faSackDollar} variant="accent" footnote="vs. ontem" />
      <Tile query={faturamentoMensal} label="Faturamento Mensal" icon={faCalendarDays} variant="accent2" footnote="vs. mês anterior" />
      <Tile query={margemLucro} label="Margem de Lucro" icon={faChartPie} variant="good" footnote="vs. mês anterior" />
      <Tile query={ticketMedio} label="Ticket Médio" icon={faReceipt} variant="accent" footnote="últimos 7 dias" />
      <Tile query={totalVendas} label="Total de Vendas" icon={faCartShopping} variant="accent2" footnote="últimos 7 dias" />
    </div>
  );
};

export default AnalyticsStats;
